import ReactDOM from 'react-dom/client';
import './index.scss';
import '@ant-design/v5-patch-for-react-19';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
